import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-right"
}
const _hoisted_2 = { class: "flex whitespace-nowrap pt-6" }
const _hoisted_3 = { class: "sm:flex-1 hidden sm:flex" }
const _hoisted_4 = { class: "inline-flex rounded-md shadow-sm" }
const _hoisted_5 = { class: "flex-1 sm:text-center" }
const _hoisted_6 = { class: "inline-flex rounded-md shadow-sm" }
const _hoisted_7 = { class: "flex-1 text-right" }
const _hoisted_8 = { class: "inline-flex rounded-md shadow-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaperHero = _resolveComponent("PaperHero")!
  const _component_GraphView = _resolveComponent("GraphView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PaperHero, { paper: _ctx.paper }, null, 8, ["paper"]),
    (this.connectingResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_GraphView, {
            graphData: _ctx.graphData,
            loaded: _ctx.loaded
          }, null, 8, ["graphData", "loaded"]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToLitConnector())),
            class: "text-xs hover:underline text-violet-600"
          }, " View in Literature Connector >> ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back())),
            class: "button-gray"
          }, " Back ")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToPaper && _ctx.goToPaper(...args))),
            class: "button-light-violet"
          }, " Go to Graph ")
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addToLitReview())),
            class: "button-violet"
          }, " Add to Lit Review ")
        ])
      ])
    ])
  ]))
}